var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPovertyStreamlineCore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_52)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5715 3.57289C12.5715 4.25488 12.8425 4.90893 13.3247 5.39117C13.8069 5.8734 14.461 6.14432 15.143 6.14432C15.8249 6.14432 16.479 5.8734 16.9612 5.39117C17.4435 4.90893 17.7144 4.25488 17.7144 3.57289C17.7144 2.89091 17.4435 2.23686 16.9612 1.75462C16.479 1.27238 15.8249 1.00146 15.143 1.00146C14.461 1.00146 13.8069 1.27238 13.3247 1.75462C12.8425 2.23686 12.5715 2.89091 12.5715 3.57289Z",
    stroke: "#EA7F4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 12.5733V11.2875C19.0001 9.15724 17.2732 7.4303 15.143 7.4303C13.6903 7.4303 12.4252 8.23331 11.7673 9.41964",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28589 3.57289C2.28589 4.25488 2.55681 4.90893 3.03904 5.39117C3.52128 5.8734 4.17533 6.14432 4.85732 6.14432C5.5393 6.14432 6.19336 5.8734 6.67559 5.39117C7.15783 4.90893 7.42875 4.25488 7.42875 3.57289C7.42875 2.89091 7.15783 2.23686 6.67559 1.75462C6.19336 1.27238 5.5393 1.00146 4.85732 1.00146C4.17533 1.00146 3.52128 1.27238 3.03904 1.75462C2.55681 2.23686 2.28589 2.89091 2.28589 3.57289Z",
    stroke: "#EA7F4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5733V11.2875C1 9.15724 2.72694 7.4303 4.85723 7.4303C6.30987 7.4303 7.57496 8.23331 8.23281 9.41964",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43018 11.2843C7.43018 11.9663 7.70109 12.6204 8.18333 13.1026C8.66557 13.5848 9.31962 13.8557 10.0016 13.8557C10.6836 13.8557 11.3376 13.5848 11.8199 13.1026C12.3021 12.6204 12.573 11.9663 12.573 11.2843C12.573 10.6023 12.3021 9.94828 11.8199 9.46604C11.3376 8.98381 10.6836 8.71289 10.0016 8.71289C9.31962 8.71289 8.66557 8.98381 8.18333 9.46604C7.70109 9.94828 7.43018 10.6023 7.43018 11.2843Z",
    stroke: "#EA7F4A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.859 18.9985C13.859 16.8682 12.132 15.1414 10.0017 15.1414C7.87146 15.1414 6.14453 16.8682 6.14453 18.9985",
    stroke: "#215250",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_52"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPovertyStreamlineCore);
export default __webpack_public_path__ + "static/media/No-Poverty--Streamline-Core.fa22d3e0b43e865c7c3162aef6684a08.svg";
export { ForwardRef as ReactComponent };